import React , {useState} from 'react';
import {useQuery} from 'react-query';
import { GetCacheKey } from '../../services/common/utils';
import MyAccount from './my-account';
import PageShimmer from '../../components/loader/skeletons/common/page-shimmer';
import HeaderComponent from '../../components/header';
import ErrorMessage from '../../components/messaging/errormessage';
import { useTranslation } from 'react-i18next';


export default function MyAccountIndex() {
    const [pmsItem, setPmsItem] = useState([]);
    const {t} = useTranslation()
    const {data:{dataLoaded}={},
            isLoading,
            isFetching,
            isLoadingError,
            isError,
            error
        }= useQuery([GetCacheKey('myaccount'), '/v6/api/pms/getpagemodules', {"name": "rn_myaccount_v4"}, {}],{
        onSuccess: ({data})=>{
            if(data?.status !== "=1"){
                const {data: result}= data
                if(result?.length > 0 ){
                    console.log(result[0]);
                    setPmsItem(result[0]);
                }
            }
        }
    });

    if(isLoading || isFetching){
        return <PageShimmer/>
    }
    if(error || isError || isLoadingError ){
        return <ErrorMessage message={t("Invalid")}/>
    }
    
  return (<div>
    <HeaderComponent type={15} />
    {pmsItem && <MyAccount pmsItem={pmsItem}/> }
  </div>)
}

